


















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { MessageModule, messageActions } from '@/store/types';

const HasRead = () => import('./HasRead.vue');
const NotRead = () => import('./NotRead.vue');
const Components = [NotRead, HasRead];
const Module = namespace(MessageModule);
@Component
export default class Message extends Vue {
  private tabs: string[] = ['未读' , '已读'];
  private selectTab = 0;
  @Module.Action(messageActions.GET_USER_MESSAGES)
  private getMessages!: () => void;
  private get component() {
    return Components[this.selectTab];
  }
  private created() {
    this.getMessages();
  }
  private activated() {
    this.getMessages();
  }
  private deactivated() {
    this.getMessages();
  }
}
